import { Component, OnInit } from '@angular/core'

@Component({
  selector: 'app-view-info',
  templateUrl: './view-info.component.html',
  styleUrls: ['./view-info.component.scss']
})
export class ViewInfoComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
